var exports = {
  "k": "x61f99309--c7ea19--container",
};

module.exports = exports;
